import { Link } from "react-router-dom";
import myImage from "../assets/img/adnan-afzal.jpg";

function About() {

    const styles = {
        myImage: {
            width: "100%"
        }
    };

    return (
        <>
            <div className="container-xxl py-5 bg-dark page-header mb-5">
                <div className="container my-5 pt-5 pb-4">
                    <h1 className="display-3 text-white mb-3 animated slideInDown">About</h1>
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb text-uppercase">
                            <li className="breadcrumb-item">
                                <Link to="/">Home</Link>
                            </li>
                            
                            <li className="breadcrumb-item active" aria-current="page">
                                <Link to="/about" className="text-white">About</Link>
                            </li>
                        </ol>
                    </nav>
                </div>
            </div>

            <div className="container-xxl py-5">
                <div className="container">
                    <div className="wow fadeInUp" data-wow-delay="0.5s">
                        <div className="row g-4">
                            <div className="col-md-4">
                                <img src={ myImage }
                                    style={ styles.myImage } />
                            </div>

                            <div className="col-md-8">
                                <h1>Adnan Afzal</h1>

                                <p className="mt-5">Hi, I'm Adnan Afzal — a passionate full-stack developer with a focus on building modern web applications and SaaS platforms. With a strong grip on technologies like Laravel, React, Node.js, and MongoDB, I aim to create fast, scalable, and user-friendly digital solutions.</p>

                                <p>I believe in clean code, thoughtful UI/UX, and solving real-world problems through technology. Whether it's white-label solutions for agencies or launching my own SaaS products, I'm driven by innovation and quality.</p>

                                <p>When I'm not coding, you'll probably find me exploring new ideas, building side projects, or quietly strategizing my next digital venture.</p>

                                <p>I share tutorials and development tips on my YouTube channel and stay connected with fellow tech enthusiasts on Facebook.</p>

                                <ul className="list-style-none">
                                    <li>🔗 <a href="https://youtube.com/c/AdnanAfzal565" target="_blank">YouTube Channel</a></li>

                                    <li>🔗 <a href="https://web.facebook.com/ComputerProgrammingTutorial" target="_blank">Facebook</a></li>
                                </ul>

                                <p>Let's build something impactful together.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default About;